module.exports = __webpack_public_path__ + "img/step.1ce399a2.png";